(function () {
  const MONTHS = [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ];

  const WEEKDAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  function addBusinessDays(startDate, businessDays) {
    const result = new Date(startDate.getTime());
    let added = 0;

    while (added < businessDays) {
      result.setDate(result.getDate() + 1);
      if (!isWeekend(result)) {
        added += 1;
      }
    }

    return result;
  }

  function formatGermanDate(date) {
    return `${WEEKDAYS[date.getDay()]} ${date.getDate()} ${MONTHS[date.getMonth()]}`;
  }

  function getProcessingStart(cutoffHour) {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    if (now.getHours() >= cutoffHour) {
      start.setDate(start.getDate() + 1);
    }

    while (isWeekend(start)) {
      start.setDate(start.getDate() + 1);
    }

    return start;
  }

  function buildDeliveryRange(minDays, maxDays, cutoffHour) {
    const processingStart = getProcessingStart(cutoffHour);
    const minDate = addBusinessDays(processingStart, minDays);
    const maxDate = addBusinessDays(processingStart, maxDays);

    if (minDate.getTime() === maxDate.getTime()) {
      return formatGermanDate(minDate);
    }

    return `${formatGermanDate(minDate)} – ${formatGermanDate(maxDate)}`;
  }

  function initDeliveryPreview(root) {
    const dateTarget = root.querySelector('[data-delivery-dates]');
    if (!dateTarget) return;

    const minDays = parseInt(root.dataset.minDays, 10) || 2;
    const maxDays = Math.max(minDays, parseInt(root.dataset.maxDays, 10) || 4);
    const cutoffHour = parseInt(root.dataset.cutoffHour, 10);
    const safeCutoff = Number.isFinite(cutoffHour) ? cutoffHour : 14;

    dateTarget.textContent = buildDeliveryRange(minDays, maxDays, safeCutoff);
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-product-delivery-preview]').forEach(initDeliveryPreview);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target) initAll(event.target);
  });
})();
